import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useHotjar() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/auth")) return;

    const w = window as any;
    if (w.hj) return; // already loaded

    w.hj = w.hj || function () { (w.hj.q = w.hj.q || []).push(arguments); };
    w._hjSettings = { hjid: 1738590, hjsv: 6 };

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://static.hotjar.com/c/hotjar-${w._hjSettings.hjid}.js?sv=${w._hjSettings.hjsv}`;
    document.head.appendChild(script);
  }, [location.pathname]);
}
